// extracted by mini-css-extract-plugin
export default {"clock-marker":"styles_clock-marker__1mrZy","clock-marker__dot":"styles_clock-marker__dot__eYmk3","clock-marker__time":"styles_clock-marker__time__5vnT4"};